import {
  FETCH_LOCKBOX_UPLOADS,
  HANDLE_ERROR,
  RECEIVED_READINGS_SUBMISSION,
  SET_LOADING,
} from "./actions";

// Initial State
const LockboxsUploadInitialState = {
  isLoading: false,
  error: null,
  data: {
    previousLockboxUploads: [],
    previewUploadedLockboxs: [],
  },
};

// State
export default (state = LockboxsUploadInitialState, action) => {
  switch (action.type) {
    case FETCH_LOCKBOX_UPLOADS:
      const uploadData = Object.assign({}, state.data, {
        previousLockboxUploads: action.previousLockboxUploads,
      });
      return { ...state, data: uploadData, isLoading: false };

    case RECEIVED_READINGS_SUBMISSION:
      const readingsData = Object.assign({}, state.data, {
        previewUploadedLockboxs: action.previewUploadedLockboxs,
      });
      return { ...state, data: readingsData, isLoading: false };

    case SET_LOADING:
      return Object.assign({}, state, { isLoading: action.isLoading });

    case HANDLE_ERROR:
      return Object.assign({}, state, {
        error: action.error,
        isLoading: false,
      });

    default:
      return state;
  }
};
